import React from 'react';

const ItemPlace = (props) => {

    return <div>
        <div className={'Place ' + props.className}  ></div>
        <img className={'ItemsImg ' + props.className} src={props.src} onClick={props.onClick} alt ='' />
        </div>
}

export default ItemPlace;